import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* financialStatementChangeReadinessStatus(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_REQUEST
    });

    const res = yield call(Http.patch, `financial-statements/${action.payload?.statementId}/readiness-status`, {
      ...action.payload
    });

    yield put({
      type: Constants.PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_FINANCIAL_STATEMENTS_LIST_OUTDATE_REQUESTS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res?.data?.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchFinancialStatementChangeReadinessStatus() {
  yield takeEvery(Constants.PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_START, financialStatementChangeReadinessStatus);
}
